module.exports = __webpack_public_path__ + "img/laser.c4d16ad.png";